import React, { useState } from "react";
import { CrfItemCodeValTypeTextSpec } from "maven-lib/dist/consts/edc";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrIcon } from "./CrIcon";
import { HbText } from "./HbText";
import { IconPackageName } from "../interface/Icon";

interface HbCheckItemSpec {
  id: string;
  val: string | number | null;
  icon?: IconPackageName;
  text: string;
  typeText?: CrfItemCodeValTypeTextSpec;
}

interface HbCheckProps {
  currentValuesAll: Array<{ itemId: string | null; dbVal: string | number | null }>;
  disabled?: boolean;
  item: HbCheckItemSpec;
  onValueChange: (value: Array<{ itemId: string | null; dbVal: string | number | null }>) => void;
}

export function HbCheck(props: HbCheckProps) {
  const { disabled, onValueChange, currentValuesAll, item } = props;
  const { val, icon, text, typeText, id } = item;
  const currentDbVal = currentValuesAll.find(v => v.itemId === id)?.dbVal;
  const typeTextValue = currentValuesAll.find(v => v.itemId === typeText?.id)?.dbVal
  const [isTextFocusOn, setIsTextFocusOn] = useState<boolean>(false);

  return (
    <div
      key={id}
      className={classNames("hb-check-item", currentDbVal && "--selected", disabled && "--disabled")}
      onClick={() => {
        if (disabled) return;

        onValueChange(currentValuesAll.map(v => {
          if (v.itemId === id) {
            return { itemId: v.itemId, dbVal: currentDbVal ? null : val };
          } else if (currentDbVal && typeText && v.itemId === typeText.id) {
            return { itemId: v.itemId, dbVal: null };
          }
          return v;
        }));

        setIsTextFocusOn(!currentDbVal);
      }}
    >
      <div>
        {icon && (
          <span className={`hb-check-item-icon --${icon.package.toLowerCase()}`}>
            <CrIcon icon={icon} />
          </span>
        )}
        <span className="hb-check-item-text">{text}</span>
        {typeText && (
          <HbText
            placeholder={typeText.placeholder}
            defaultVal={typeTextValue}
            disabled={!currentDbVal || disabled}
            isTextFocusOn={isTextFocusOn}
            onValueChange={value => {
              if (disabled) return;

              onValueChange(currentValuesAll.map(v => v.itemId === typeText.id ? { ...v, dbVal: value } : v));
            }}
            onClickEvent={(el) => {
              el.stopPropagation();
            }}
          />
        )}
      </div>
    </div>
  );
}
